import * as React from 'react'
import type { SVGProps } from 'react'

function Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 220.83 226.08"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        style={{
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '4px',
        }}
      >
        <path
          d="M116.55,192.02c-6.04,1.19-12.28,1.82-18.66,1.82-52.96,0-95.88-42.93-95.88-95.88S44.93,2.07,97.88,2.07c35.72,0,66.88,19.53,83.38,48.5"
          style={{ fill: 'none', stroke: 'currentColor' }}
        />
        <line
          style={{ fill: 'none', stroke: 'currentColor' }}
          x1="139.78"
          x2="2"
          y1="101.39"
          y2="101.39"
        />
        <path
          d="M173.33,38.76c-9.07,4.09-18.39,7.4-27.87,9.93-15.25,4.09-30.92,6.17-46.59,6.25-15.7.09-31.4-1.83-46.72-5.77h0c-10.1-2.59-20.04-6.06-29.69-10.41"
          style={{ fill: 'none', stroke: 'currentColor' }}
        />
        <path
          d="M145.46,48.69c-3.95-14.39-9.69-28.4-17.22-41.71"
          style={{ fill: 'none', stroke: 'currentColor' }}
        />
        <path
          d="M70.62,189.9c-6.86-11.79-12.3-24.15-16.32-36.83-5.33-16.82-8.19-34.23-8.56-51.68-.38-17.55,1.75-35.15,6.4-52.22h0c4.02-14.84,9.95-29.28,17.78-42.96"
          style={{ fill: 'none', stroke: 'currentColor' }}
        />
        <path
          d="M134.32,151.47c-11.7-2.37-23.57-3.58-35.45-3.63-14.96-.09-29.94,1.66-44.57,5.23-9.37,2.28-18.61,5.32-27.61,9.11"
          style={{ fill: 'none', stroke: 'currentColor' }}
        />
        <line
          style={{ fill: 'none', stroke: 'currentColor' }}
          x1="98.87"
          x2="98.87"
          y1="193.9"
          y2="2"
        />
        <path
          d="M184.45,165.07v-89.35c0-9.08-7.36-16.43-16.43-16.43h0c-9.07,0-16.43,7.36-16.43,16.43v89.83c-9.54,5.99-15.67,16.92-14.78,29.21,1.14,15.74,13.45,28.08,29.19,29.24,18.59,1.38,34.11-13.3,34.11-31.6,0-11.65-6.29-21.82-15.65-27.33Z"
          style={{ fill: 'none', stroke: 'currentColor' }}
        />
        <circle
          cx="168.3"
          cy="192.02"
          r="14.05"
          style={{ fill: 'none', stroke: 'currentColor' }}
        />
        <line
          style={{ fill: 'none', stroke: 'currentColor' }}
          x1="168.3"
          x2="168.3"
          y1="102.83"
          y2="177.98"
        />
        <line
          style={{ fill: 'none', stroke: 'currentColor' }}
          x1="207.81"
          x2="207.81"
          y1="102.47"
          y2="165.26"
        />
        <polyline
          points="218.83 120.09 207.81 101.37 196.8 120.09"
          style={{ fill: 'none', stroke: 'currentColor' }}
        />
      </g>
    </svg>
  )
}

export default Icon
